export default "__VITE_ASSET__DSfAoHk4__"